<template>
  <div class="page-container">
    <div class="query-title">分仓配送时效查询</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form
              ref="form"
              :model="conditions"
              inline
              class="form"
              size="mini"
              label-width="100px"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item label="起运城市" prop="fromcity">
                    <el-select
                      v-model="conditions.fromcity_v"
                      filterable
                      clearable
                      @change="changeSelect($event, 's', 'fromcity')"
                    >
                      <el-option v-for="item in startCitys" :key="item.CITY_CODE" :value="item.CITY_CODE" :label="item.CITY_NAME" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省">
                    <el-select
                      v-model="conditions.region"
                      filterable
                      clearable
                      @change="changeSelect($event, 'region', 'province')"
                    >
                      <el-option v-for="item in selectDataOptions['region']" :key="item.BLAND" :value="item.BLAND" :label="item.BEZEI" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="市" prop="city">
                    <el-select
                      v-model="conditions.city_v"
                      filterable
                      clearable
                      @change="changeSelect($event, 'city', 'city')"
                    >
                      <el-option v-for="item in selectDataOptions['city']" :key="item.CITY_CODE" :value="item.CITY_CODE" :label="item.CITY_NAME" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="县">
                    <el-select
                      v-model="conditions.district_v"
                      filterable
                      clearable
                      @change="changeSelect($event, 'district', 'district')"
                    >
                      <el-option v-for="item in selectDataOptions['district']" :key="item.STRT_CODE" :value="item.STRT_CODE" :label="item.MC_STREET" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="生效日期">
                    <el-date-picker
                      v-model="conditions.validate"
                      value-format="yyyy-MM-dd"
                      type="date"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="导入日期">
                    <el-date-picker
                      v-model="conditions.importedDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>
      <div class="table-container">
        <TableCommon
          title="明细"
          :custome-config="() => vxeShowCustom('xTable')"
        >
          <template #button>
            <table-button name="export" tip="修改" @click="toEdit" />
            <table-button name="export" tip="设置生效日期" @click="setTime" />
            <table-button name="import" tip="导入" @click="importLogistic" />
            <table-button name="download" tip="下载模版" @click="downloadTem" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="400"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <template #adjustDeliveryNum="{ row }">
              <el-input
                v-model="row['adjustDeliveryNum']"
                placeholder="请输入"
                type="number"
                size="mini"
                @input="updateNum(row)"
              />
            </template>
            <template #cause="{ row }">
              <el-input v-model="row['cause']" placeholder="请输入" size="mini" />
            </template>
          </vxe-grid>
        </TableCommon>
      </div>
    </div>
  </div>
</template>

<script>
import { apiLogisticSagingFindList } from '@/api/applyForGoods/logisticsAbnormal'
import { apiExportExcelTemplate, apiExcelImport, apiGetExcelImportData, apiSaveExcelImportData } from '@/api/common'
import { getToken } from '@/utils/auth'
import { getArea } from '@/api/sap/common-sap'
import { DOWNLOAD_API } from '@/api/baseUrl'
export default {
  data() {
    return {
      currentRow: {},
      conditions: {
        'city': '',
        'district': '',
        'fromcity': '',
        fromcity_v: '',
        province_v: '',
        city_v: '',
        district_v: '',
        'importedDate': '',
        'province': '',
        'validate': ''
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      // date1: null,
      // date2: null,
      temconditions: {
        batchNumber: '',
        templateCode: 'materialFlowImport'
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { field: 'importedDate', title: '导入日期', width: 140 },
          { field: 'productName', title: '修改日期' },
          { field: 'validate', title: '生效日期' },
          { field: 'fromcity', title: '启运城市', width: 80 },
          { field: 'province', title: '省', width: 80 },
          { field: 'city', title: '市', width: 80 },
          { field: 'district', title: '县', width: 80 },
          { field: 'readyTime', title: '备货时效', width: 80 },
          { field: 'transportionTime', title: '运输时效', width: 80 },
          { field: 'transferTimeUnder100', title: '100件以下中转时效' },
          { field: 'comment', title: '备注' }
        ],
        data: []
      },
      selectDataOptions: {
        city: [],
        region: [],
        district: []
      },
      startCitys: []
    }
  },
  watch: {
  },
  created() {
    getArea('', 'city', 'X').then(res => {
      this.startCitys = res.DATA
    })
    getArea('', 'region').then(res => {
      this.selectDataOptions.region = res.DATA
    })
  },
  methods: {
    async queryData() {
      const params = {
        ...this.conditions
      }
      this.loading = true
      const { data } = await apiLogisticSagingFindList(params)
      this.gridOptions.data = data
      this.loading = false
    },
    changeSelect(e, type, field) {
      if (e) {
        this.filterName(...arguments)
        if (type === 'region') {
          getArea(e, 'city').then(res => {
            this.selectDataOptions['city'] = res.DATA
          })
          this.conditions.city = ''
          this.conditions.city_v = ''
          this.conditions.district = ''
          this.conditions.district_v = ''
        } else if (type === 'city') {
          getArea(e, 'street').then(res => {
            this.selectDataOptions['district'] = res.DATA
          })
          this.conditions.district = ''
          this.conditions.district_v = ''
        }
      } else {
        this.conditions[field] = ''
      }
    },
    // 处理下拉框选择之后的描述处理
    filterName(e, type, field) {
      const tmp = {
        city: {
          label: 'CITY_NAME',
          value: 'CITY_CODE'
        },
        region: {
          label: 'BEZEI',
          value: 'BLAND'
        },
        district: {
          label: 'MC_STREET',
          value: 'STRT_CODE'
        }
      }
      if (type === 's') {
        this.conditions[field] = this.startCitys.find(v => v[tmp.city.value] === e)[tmp.city.label]
      } else {
        this.conditions[field] = this.selectDataOptions[type].find(v => v[tmp[type].value] === e)[tmp[type].label]
      }
    },
    toEdit() {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (!data.length) return this.$message.warning('请选择要操作的数据！')
      if (data.length > 1) return this.$message.warning('请选择一条数据！')

      this.$router.push({
        path: '/wly/to-goods/base-setting/warehouse-logistics-timeliness-maintain',
        query: {
          id: data[0].id
        }
      })
    },
    importLogistic() {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.temconditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.temconditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      // 查询导入的数据
      // const params = { ...this.temconditions, page: 1, pagesize: 1000 }
      // const res = await apiGetExcelImportData(params)
      // this.gridOptions.data = res.data.Rows

      const formData = new FormData()
      formData.append('batchNumber', this.temconditions.batchNumber)
      formData.append('templateCode', this.temconditions.templateCode)

      // 保存
      const result = await apiSaveExcelImportData(formData)
      if (result.status === 1) {
        this.$message.success('导入成功!')
      }
      this.queryData()
      // for (const item of res.data.Rows) {
      //   Object.keys(item).forEach(key => {
      //     item[this.toLineAndUp(key)] = item[key]
      //     delete item[key]
      //   })
      // }
      // sap 检查数据
      // this.checkDataAndSave(res.data.Rows, 'X')
    },
    async downloadTem(type = 'materialFlowImport', fileName = '分仓配送时效批导模版') {
      // 模板下崽
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    setTime() {},
    reset() {
      this.conditions = {
        'city': '',
        'district': '',
        'fromcity': '',
        'importedDateEnd': '',
        'importedDateStart': '',
        'province': '',
        'validateEnd': '',
        'validateStart': ''
      }
      // this.date1 = null
      // this.date2 = null
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/warehouseLogisticsTimeliness.vue